import React, { useState } from "react";
import { Button, Input, Table, Tooltip } from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import moment from "moment";
import AddPosition from "./AddPosition";
import EditPosition from "./EditPosition";

const PositionList = ({ positionList, rerun, limit }) => {
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const tableLayout = "";
  const scroll = {};
  const [editDrawer, setEditDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [search, setSearch] = useState("");

  const columns = [
    {
      title: "Date Created",
      dataIndex: "created_at",
      render: (date) => (
        // <p>{moment(new Date(date), "YYYY-MM-DD").format("MMMM DD, YYYY")}</p>
        <p>{moment.utc(new Date(date)).format("MMMM DD, YYYY")}</p>
      ),
    },
    {
      title: "Position",
      dataIndex: "position",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 40,
      render: (text) => (
        <p>
          <Tooltip title="Edit">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setEditDrawer(true);
              }}
              icon={<EditOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const searchable = positionList.data.filter((data) => {
    return data.position.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <Input
            id="search"
            placeholder="Search position"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setOpenDrawer(true)}
          disabled={positionList.data.length >= parseInt(limit)}
        >
          Add Position
        </Button>
      </div>

      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.id}
        />
      </div>

      {openDrawer && (
        <AddPosition
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          rerun={() => rerun()}
          limit={limit}
        />
      )}

      {editDrawer && (
        <EditPosition
          open={editDrawer}
          close={() => setEditDrawer(false)}
          setLoading={setLoading}
          rerun={() => rerun()}
          selectedData={selectedData}
        />
      )}
    </>
  );
};

export default PositionList;
